import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["error", "text", "className"];
import { clsx } from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
export var BaseInputHelperText = function BaseInputHelperText(_ref) {
  var error = _ref.error,
    text = _ref.text,
    className = _ref.className,
    rest = _objectWithoutProperties(_ref, _excluded);
  var notError = !error;
  return /*#__PURE__*/_jsx("span", _objectSpread(_objectSpread({
    className: clsx('tw-font-caption', className, {
      'tw-text-alert-400 dark:tw-text-alert-300': error,
      'tw-text-neutral-light-700 dark:tw-text-neutral-dark-500': notError
    })
  }, rest), {}, {
    children: text
  }));
};
export default BaseInputHelperText;